import React, { Component } from 'react';
import { Checkbox, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import PatientBreadcrumb from './patientBreadcrumb';

import GridMultiSelectField from '../../../common/GridMultiSelectField';
class PatientSearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <PatientBreadcrumb
                    onIsArchivedInformation={(event) => {
                        this.props.onIsArchivedInformation(event);
                    }}
                    isArchived={this.props.isArchived}
                />
                <div className="row" style={{ padding: ' 12px' }}>
                    <div className="col-md-8" style={{ borderRight: '2px solid lightGray' }}>
                        <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-5">
                                <FormControl variant="outlined" style={{ width: '100%', marginTop: '5px' }}>
                                    <InputLabel id="facility-label">Select Facility</InputLabel>
                                    {this.props.facilities && this.props.facilities.length <= 1 && (
                                        <Select
                                            labelId="facility-label"
                                            id="facility-select"
                                            value={
                                                this.props.facilityId && this.props.facilityId.length
                                                    ? this.props.facilityId
                                                    : ''
                                            }
                                            onChange={this.props.handleFiltersChange}
                                            name="facility_id"
                                        >
                                            {this.props.facilities.map((fac) => {
                                                return (
                                                    <MenuItem key={fac._id} value={fac._id}>
                                                        <span className="mr-2">{fac.name}</span>
                                                        {fac.archived === 'archived' && <b>{' ( Archived )'}</b>}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    )}
                                    {this.props.facilities && this.props.facilities.length > 1 && (
                                        <GridMultiSelectField compact
                                            labelId="facility-label"
                                            id="facility-select"
                                            value={this.props.facilityId}
                                            onChange={this.props.handleFiltersChange}
                                            label="Select Facility"
                                            name="facility_id"
                                            multiple
                                            renderValue={(selected) => {
                                                if (selected.length === this.props.facilities.length) {
                                                    return 'All Facilities';
                                                } else {
                                                    let displayStrings = [];
                                                    this.props.facilities.map((fac) => {
                                                        if (selected.includes(fac._id)) {
                                                            displayStrings.push(fac.name);
                                                        }
                                                        return null;
                                                    });
                                                    return displayStrings.join(', ');
                                                }
                                            }}
                                        >
                                            <MenuItem
                                                className={
                                                    this.props.facilityId &&
                                                    this.props.facilityId.length === this.props.facilities.length
                                                        ? 'Mui-selected'
                                                        : ''
                                                }
                                                key="all"
                                                value="all"
                                            >
                                                <Checkbox
                                                    checked={
                                                        this.props.facilityId &&
                                                        this.props.facilityId.length === this.props.facilities.length
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                All Facilities
                                            </MenuItem>
                                            {this.props.facilities.map((fac) => {
                                                return (
                                                    <MenuItem key={fac._id} value={fac._id}>
                                                        <Checkbox
                                                            checked={
                                                                this.props.facilityId &&
                                                                this.props.facilityId.includes(fac._id)
                                                                    ? true
                                                                    : false
                                                            }
                                                            className={fac.type === 'facility' ? 'ml-5' : ''}
                                                        />
                                                        <span className="mr-2">{fac.name}</span>
                                                        {fac.archived === 'archived' && <b>{' ( Archived )'}</b>}
                                                    </MenuItem>
                                                );
                                            })}
                                        </GridMultiSelectField>
                                    )}
                                </FormControl>
                            </div>
                            <div className="col-md-3">
                                <TextField
                                    label="Current Grid Search"
                                    variant="outlined"
                                    id="reset-form"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    type="string"
                                    margin="dense"
                                    onChange={this.props.onFilterTextChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <button
                                    className="btn btn-primary button-info-grid"
                                    onClick={() => this.props.clearFilter()}
                                >
                                    <i className="fa fa-times" aria-hidden="true"></i> Clear Filters
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col grid-buttons">
                                <div>
                                    <TextField
                                        style={{ width: '100px' }}
                                        label="Page Size"
                                        variant="outlined"
                                        className="mt-3"
                                        id="page-size"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        type="number"
                                        size="small"
                                        margin="none"
                                        onChange={this.props.onPageSizeChanged}
                                    />
                                </div>
                                <div>
                                    <button
                                        className="btn btn-primary button-info-grid"
                                        onClick={() => this.props.saveState()}
                                    >
                                        <i className="far fa-save"></i> Save
                                    </button>
                                    <button
                                        className="btn btn-primary button-info-grid"
                                        onClick={() => this.props.resetState()}
                                    >
                                        {' '}
                                        <i className="fa fa-repeat"></i> Default
                                    </button>
                                    <button
                                        className="btn btn-primary button-info-grid"
                                        onClick={() => this.props.onBtnExport()}
                                    >
                                        <i className="fa fa-file-excel-o" aria-hidden="true"></i> Export
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PatientSearchMenu;
